package com.milta.core.localization.translations.nl

import com.milta.core.localization.UnlocatedDeliveryStrings

internal val UnlocatedDelivery = UnlocatedDeliveryStrings(
    warningTitleSingular = "1 adres niet gelokaliseerd",
    warningTitlePlural = "%d adressen niet gelokaliseerd",
    warningMessage = "Deze leveringen konden niet op de kaart worden geplaatst. Corrigeer hun adres, of ga verder: ze worden aan het einde van de route gezet.",
    fixAction = "Corrigeren",
    continueWithoutAction = "Doorgaan zonder deze",
    unplacedStopsSingular = "1 stop niet geplaatst, aan het einde van de route",
    unplacedStopsPlural = "%d stops niet geplaatst, aan het einde van de route",
    fixAddressAction = "Adres corrigeren",
    unlocatedBadge = "Niet gelokaliseerd",
)
